
export default class ProposalDocument {
    constructor(
        public readonly id: string,
        public readonly createdAt: number,
        public readonly name: string,
        public readonly path: string,
    ) {}
}
